import { MakeCall } from './createMakeCall';
import {
  CreateChangeRequestPayload,
  ChangeRequestResponse,
} from './types/ChangeRequest';

/**
 * Handles creating booking change requests (modificaiton, cancellation, rebooking)
 * @param {number} conversationId unique identifier for the conversation
 * @param {CreateChangeRequestPayload} payload payload
 * @returns change request created response
 */
export const createChangeRequest =
  (makeCall: MakeCall) =>
  (conversationId: number, payload: CreateChangeRequestPayload) =>
    makeCall<ChangeRequestResponse>(
      'POST',
      `/api/v2/conversation/${conversationId}/change`,
      { data: payload },
    );
